import React, { useEffect } from 'react'
import {Link, useNavigate } from 'react-router-dom'
import { clearLocalStorage, deleteCookie } from '../utils/Utils'
import LandingPage from '../components/LandingPage'
import { useTranslation } from 'react-i18next'

const SessionExpired = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { Sessiontimedout } = t('sessionexpiredpage')

  useEffect(() => {
    deleteCookie('idcs_id_token')
    deleteCookie('idcs_user_assertion')
    deleteCookie('role')
    clearLocalStorage()
    // setTimeout(() => {
    //   navigate('/login')
    // }, 2000) // Wait for 2 seconds before redirecting
  }, [])

  const goToLogin = () => {
    window.location.href = '/login'
  }
  const path = window.location.pathname;

  let message = "Something went wrong. Please try again.";
  
  if (path === "/access-forbidden") {
    message = "You do not have permission to access this resource.";
  } else if (path === "/unauthorized-access") {
    message = "Unauthorized Access";
  } else if (path === "/service-unavailable") {
    message = "Service Unavailable";
  } else if(path === "/unexpected-error"){
    message = "Something went wrong. Please try again"
  } else if (path === "/session-timeout"){
    message = "Your session has ended"
  }


  return (
    //replaced this message
    // <div>
    //   <h1>Your session seems to have expired, logging you out...</h1>
    // </div>
    <LandingPage>
      <div className="flex flex-col items-center justify-center ">
        <div className="bg-white p-6 rounded-lg ">
        <h1 className="text-2xl font-bold mb-4">{message}</h1>
        {path === "/session-timeout" ? 
        <p className="mb-4">
        Please <Link to="/login" className="text-blue-500 underline">sign in</Link> again to return to PO Connect.
       </p>
       :  <button className={`bg-blue-500 text-white h-[37px] px-3 rounded-md text-sm `} onClick={() => goToLogin()}>Go to Login Page</button>
        }
        </div>
      </div>

    </LandingPage>
  )
}

export default SessionExpired
